import axios from 'axios'
import store from '../store/index'
import { ElMessage } from 'element-plus'
const servers = axios.create({
  baseURL: '/api', // http://localhost:8080/api/ ,https://mingyou.darga.cn/
  timeout: 5000
})
servers.interceptors.request.use(
  (config) => {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)
servers.interceptors.response.use(

  async (response) => {
    store.state.loading = false
    const res = response.data

    if (res.code !== 200) {
      ElMessage({
        showClose: true,
        message: res.msg,
        type: 'error'
      })
      return Promise.reject(res.msg)
    }
    return res
  },
  (e) => {
    if (e && e.response) {
      switch (e.response.status) {
        case 400:
          e.msg = '请求错误(400)'
          break
        case 401:
          e.msg = '未授权,请登录(401)'
          break
        case 403:
          e.msg = '拒绝访问(403)'
          break
        case 404:
          e.msg = '请求地址出错'
          break
        case 405:
          e.msg = '请求方法未允许(405)'
          break
        case 408:
          e.msg = `请求地址出错: ${e.response.config.url}`
          break
        case 500:
          e.msg = '服务器内部错误(500)'
          break
        case 501:
          e.msg = '服务未实现(501)'
          break
        case 502:
          e.msg = '网络错误(502)'
          break
        case 503:
          e.msg = '服务不可用(503)'
          break
        case 504:
          e.msg = '网络超时(504)'
          break
        case 505:
          e.msg = 'HTTP版本不受支持(505)'
          break
        default:
          e.msg = `连接错误: ${e.msg}`
      }
    } else {
      e.msg = '连接到服务器失败，请联系管理员'
    }
    return Promise.reject(e)
  }
)
export default servers
